angular.module('kareo.authentication', [])
  .provider('kareoAuthHttpResponseInterceptor', function () {
    var httpStatusCodes = { 401: true };
    this.setHttpStatusCodes = function (statusCodes) {
      httpStatusCodes = {};
      for (var i = 0; i < statusCodes.length; i++) {
        httpStatusCodes[statusCodes[i]] = true;
      }
    };
    this.$get = [
      '$q', '$rootScope', 'authService', function ($q, $rootScope, authService) {
        return {
          'responseError': function (response) {
            if (httpStatusCodes[response.status] && !response.config.DontKareoReauth) {
              var event = 'event:auth-loginRequired';
              $rootScope.$broadcast(event, (response.status === 401));
              var retryPromise = authService.pushToRetryBuffer(response.config);
              return retryPromise;
            }
            // otherwise
            return $q.reject(response);
          }
        };
      }];
  })
  .service('authService', ['$injector', '$q', function ($injector, $q) {
    var buffer = [];
    var authenticatingPromise;
    var $http;

    function pushToRetryBuffer(config) {
      var deferred = $q.defer();
      buffer.push({
        config, deferred
      });
      return deferred.promise;
    }

    function reauth() {
      if (authenticatingPromise) {
        return authenticatingPromise.promise;
      }
      authenticatingPromise = $q.defer();
      $http = $http || $injector.get('$http');
      $http.get('/login/reauthenticate', {
        DontKareoReauth: true
      })
          .then(() => {
            loginConfirmed();
          }, () => {
            authenticatingPromise.reject();
            authenticatingPromise = null;
          });
      return authenticatingPromise.promise;
    }

    function loginConfirmed() {
      authenticatingPromise.resolve();
      authenticatingPromise = null;
      retryAll();
    }

    function retry(config, deferred) {
      config.DontKareoReauth = true;
      $http = $http || $injector.get('$http');
      $http(config).then((response) => {
        deferred.resolve(response);
      }, (response) => {
        deferred.reject(response);
      });
    }

    function retryAll() {
      for (var i = 0; i < buffer.length; ++i) {
        retry(buffer[i].config, buffer[i].deferred);
      }
      buffer = [];
    }

    function login(redirectOk) {
      if (authenticatingPromise) {
        return authenticatingPromise.promise;
      }
      authenticatingPromise = $q.defer();
      var $window = $injector.get('$window');
      try {
      // kill any outstanding state transitions
        var $state = $injector.get('$state');
        $state.transition = $q.reject('logging-out');
      } catch (e) {
      // do nothing
      }

      var currentPath = $window.location.pathname;
      var currentHash = $window.location.hash;
      var redirectUrl = `${currentPath}${currentHash}`;
      const signInPath = '/v2/#/sign-in';
      // only redirect if we're not already on the sign-in page
      if (!redirectUrl.includes(signInPath) && redirectOk) {

          const redirectQueryParams = new URLSearchParams();
          if(!!redirectUrl.trim()){
            redirectQueryParams.set('redirectTo', redirectUrl);
          }
          // $window.location.replace(`${signInPath}?${redirectQueryParams.toString()}`);
          // TODO - remove this line and uncomment the above line once tested in PM
          $window.location.href = `${signInPath}?${redirectQueryParams.toString()}`;
      }

      return authenticatingPromise.promise;
    }

    function signout() {
      var $window = $injector.get('$window');
      $window.location.href = '/signout?idle=true';
    }

    return {
      pushToRetryBuffer, retryRequests: retryAll, reauth, signout, login
    };
  }]);
